import React from "react";

const ChromeLogo = ({ size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" fill="#4285F4"/>
      <circle cx="12" cy="12" r="7" fill="#34A853"/>
      <circle cx="12" cy="12" r="3" fill="#FBBC05"/>
      <path
        d="M12 2C6.48 2 2 6.48 2 12c0 1.54.35 3 .97 4.29L8.5 8.5C9.45 7.55 10.67 7 12 7c2.21 0 4 1.79 4 4 0 .55-.11 1.08-.31 1.56L21.03 7.71C19.65 4.69 16.06 2 12 2z"
        fill="#EA4335"
      />
      <path
        d="M2.97 16.29C4.35 19.31 7.94 22 12 22c1.33 0 2.55-.26 3.69-.73L10.31 15.44C9.56 15.8 8.72 16 7.83 16c-2.21 0-4-1.79-4-4 0-.44.07-.86.19-1.27L2.97 16.29z"
        fill="#34A853"
      />
      <path
        d="M21.03 7.71L15.69 13.56c.2-.48.31-1.01.31-1.56 0-2.21-1.79-4-4-4-1.33 0-2.55.55-3.5 1.5L2.97 7.71C4.35 4.69 7.94 2 12 2c4.06 0 7.65 2.69 9.03 5.71z"
        fill="#FBBC05"
      />
      <circle cx="12" cy="12" r="3" fill="white"/>
      <circle cx="12" cy="12" r="1.5" fill="#4285F4"/>
    </svg>
  );
};

export default ChromeLogo;